import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import ClassOverview from '@/components/ClassOverview/ClassOverview';

const MY_CLASSES = '/dashboard/my-classes';

/**
 * Teacher dashboard: /dashboard/my-classes/:classId
 * Same UI as admin View Class — styles: @/components/ClassOverview/ClassOverview.module.scss
 */
const MyClassDetailView: React.FC = () => {
  const navigate = useNavigate();
  const { classId } = useParams<{ classId: string }>();
  const { user } = useAppSelector(authSelector);
  const organizationId = user?.metadata?.organizationDetails?.organizationId || '';
  const fallbackTeacherName = [user?.metadata?.firstName, user?.metadata?.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();

  if (!classId) {
    return <Navigate to={MY_CLASSES} replace />;
  }
  if (!organizationId) {
    return <Navigate to={MY_CLASSES} replace />;
  }

  return (
    <ClassOverview
      classId={classId}
      organizationId={organizationId}
      canEditClass
      onBack={() => navigate(MY_CLASSES)}
      onEditClass={() => navigate(`/dashboard/my-classes/edit-class/${classId}`)}
      fallbackTeacherName={fallbackTeacherName || undefined}
      dataSource='teacher'
    />
  );
};

export default MyClassDetailView;
